import {
    FETCH_DAILY_HILL_SCORE_DATA_REPORTS,
    FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FETCHING,
    FETCH_DAILY_HILL_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_DAILY_HILL_SCORE_DATA_ONE_DAY_REPORTS_SUCCESS,
    FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FAIL,
    FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS,
    FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FETCHING,
    FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FAIL,
    FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS,
    FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FETCHING,
    FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FAIL
} from '../../actions/hillScoreActions';

const INITIAL_STATE = {
    dailyHillScoreDataOneDay: {},
    dailyHillScoreData: {},
    dailyHillScoreDataFetching: false,
    dailyHillScoreDataFetchFail: false,
    weeklyHillScoreData: {},
    weeklyHillScoreDataFetching: false,
    weeklyHillScoreDataFetchFail: false,
    monthlyHillScoreData: {},
    monthlyHillScoreDataFetching: false,
    monthlyHillScoreDataFetchFail: false
};

// ======= Daily Fetching Handlers =======
const fetchDailyHillScoreDataFetching = (state) => {
    return {
        ...state,
        dailyHillScoreDataFetching: true,
        dailyHillScoreDataFetchFail: false
    };
};

const fetchDailyHillScoreDataSuccess = (state, action) => {
    return {
        ...state,
        dailyHillScoreData: action.hillScoreData,
        dailyHillScoreDataFetching: false,
        dailyHillScoreDataFetchFail: false
    };
};
const fetchDailyHillScoreDataOneDaySuccess = (state, action) => {
    return {
        ...state,
        dailyHillScoreDataOneDay: action.hillScoreData,
        dailyHillScoreDataFetching: false,
        dailyHillScoreDataFetchFail: false
    };
};

const fetchDailyHillScoreDataFail = (state) => {
    return {
        ...state,
        dailyHillScoreData: {},
        dailyHillScoreDataOneDay: {},
        dailyHillScoreDataFetching: false,
        dailyHillScoreDataFetchFail: true
    };
};

// ======= Weekly Fetching Handlers =======
const fetchWeeklyHillScoreDataFetching = (state) => {
    return {
        ...state,
        weeklyHillScoreDataFetching: true,
        weeklyHillScoreDataFetchFail: false
    };
};

const fetchWeeklyHillScoreDataSuccess = (state, action) => {
    return {
        ...state,
        weeklyHillScoreData: action.hillScoreData,
        weeklyHillScoreDataFetching: false,
        weeklyHillScoreDataFetchFail: false
    };
};

const fetchWeeklyHillScoreDataFail = (state) => {
    return {
        ...state,
        weeklyHillScoreDataFetching: false,
        weeklyHillScoreDataFetchFail: true
    };
};

// ======= Monthly Fetching Handlers =======
const fetchMonthlyHillScoreDataFetching = (state) => {
    return {
        ...state,
        monthlyHillScoreDataFetching: true,
        monthlyHillScoreDataFetchFail: false
    };
};

const fetchMonthlyHillScoreDataSuccess = (state, action) => {
    return {
        ...state,
        monthlyHillScoreData: action.hillScoreData,
        monthlyHillScoreDataFetching: false,
        monthlyHillScoreDataFetchFail: false
    };
};

const fetchMonthlyHillScoreDataFail = (state) => {
    return {
        ...state,
        monthlyHillScoreDataFetching: false,
        monthlyHillScoreDataFetchFail: true
    };
};

const resetToInitialState = () => INITIAL_STATE;

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FETCHING]: fetchDailyHillScoreDataFetching,
    [FETCH_DAILY_HILL_SCORE_DATA_REPORTS_SUCCESS]: fetchDailyHillScoreDataSuccess,
    [FETCH_DAILY_HILL_SCORE_DATA_ONE_DAY_REPORTS_SUCCESS]: fetchDailyHillScoreDataOneDaySuccess,
    [FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FAIL]: fetchDailyHillScoreDataFail,
    [FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FETCHING]: fetchWeeklyHillScoreDataFetching,
    [FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_SUCCESS]: fetchWeeklyHillScoreDataSuccess,
    [FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FAIL]: fetchWeeklyHillScoreDataFail,
    [FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FETCHING]: fetchMonthlyHillScoreDataFetching,
    [FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_SUCCESS]: fetchMonthlyHillScoreDataSuccess,
    [FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FAIL]: fetchMonthlyHillScoreDataFail
    // [RESET_PROFILE_PAGE]: resetToInitialState
};

// ======= Default Action ======
export default function hillScoreDataReports(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDailyHillScoreData(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_DAILY_HILL_SCORE_DATA_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function fetchWeeklyHillScoreData(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function fetchMonthlyHillScoreData(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

// ======= Selectors =======
export const getDailyHillScoreData = (state) => {
    return state.hillScoreDataReports.dailyHillScoreData ? state.hillScoreDataReports.dailyHillScoreData : null;
};

export const isDailyHillScoreDataFetching = (state) => {
    return state.hillScoreDataReports.dailyHillScoreDataFetching;
};

export const didDailyHillScoreDataFetchFail = (state) => {
    return state.hillScoreDataReports.dailyHillScoreDataFetchFail;
};

export const getWeeklyHillScoreData = (state) => {
    return state.hillScoreDataReports.weeklyHillScoreData ? state.hillScoreDataReports.weeklyHillScoreData : null;
};

export const isWeeklyHillScoreDataFetching = (state) => {
    return state.hillScoreDataReports.weeklyHillScoreDataFetching;
};

export const didWeeklyHillScoreDataFetchFail = (state) => {
    return state.hillScoreDataReports.weeklyHillScoreDataFetchFail;
};

export const getMonthlyHillScoreData = (state) => {
    return state.hillScoreDataReports.monthlyHillScoreData ? state.hillScoreDataReports.monthlyHillScoreData : null;
};

export const isMonthlyHillScoreDataFetching = (state) => {
    return state.hillScoreDataReports.monthlyHillScoreDataFetching;
};

export const didMonthlyHillScoreDataFetchFail = (state) => {
    return state.hillScoreDataReports.monthlyHillScoreDataFetchFail;
};
